// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3iuH-","content":"styles_content__1gzH9","selectAll":"styles_selectAll__5Ox_9"};